import _ from 'underscore';
import Promise from 'bluebird';

function isPending(obj) {
  return (obj instanceof Promise) && obj.isPending();
}

/* eslint-disable no-param-reassign */
export function taskQueueMixin(classInstance, methodNames) {
  let asyncTaskQueue = null;

  _.each(methodNames, (methodName) => {
    const originalMethod = classInstance[methodName];

    const wrappedMethod = (...args) => {
      asyncTaskQueue = isPending(asyncTaskQueue) ?
        asyncTaskQueue.catch(_.noop).then(() => originalMethod.call(classInstance, ...args)) :
        originalMethod.call(classInstance, ...args);

      return asyncTaskQueue;
    };

    classInstance[methodName] = wrappedMethod;
  });
}
